import React, { useEffect } from 'react';
import gender from '../../assets/images/gender.svg';
import height from '../../assets/images/height.svg';
import userDefault from '../../assets/images/user-default.svg';
import { msgAlert } from '../../helper';

const PatientDetail = ({user}) => {
  useEffect(() => {
    if(Object.keys(user).length === 0) {
      msgAlert('Error...', 'User data missing', true, true);
    }
  }, [user]);
  return (
    <div className='patient-detail-card'>
      <div className="d-flex align-items-start align-items-center mb-3">
        <img className="me-3 rounded-circle" src={userDefault} width={30} alt='' />
        <h5 className="mt-0 mb-0">{user?.name}</h5>
      </div>
      <div className="d-flex align-items-start align-items-center mb-3">
        <img className="me-3 rounded-circle" src={gender} width={24} alt='' />
        <p className="mt-0 mb-0">{user?.gender}, {user?.age}</p>
      </div>
      <div className="d-flex align-items-start align-items-center">
        <img className="me-3 rounded-circle" src={height} width={24} alt='' />
        <p className="mt-0 mb-0">{user?.height}, {user?.weight}</p>
      </div>
    </div>
  );
};

export default PatientDetail;